import { FC } from "react";
import { Grid, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { formatEther } from "@framework/exchange";
import { TokenType, IMysteryBox } from "@framework/types";

import { StyledPaper, StyledTitle } from "./styled";

export interface IMysteryBoxContentProps {
  mysteryBox: IMysteryBox;
}

export const MysteryBoxContent: FC<IMysteryBoxContentProps> = props => {
  const { mysteryBox } = props;

  if (!mysteryBox) {
    return null;
  }

  return (
    <>
      <StyledTitle variant="h5">
        <FormattedMessage id="pages.mystery.box.content" />
      </StyledTitle>
      <StyledPaper elevation={1}>
        <Grid container>
          <Grid size={{ xs: 4 }}>
            <Typography fontWeight={450}>
              <FormattedMessage id="form.labels.tokenType" />
            </Typography>
          </Grid>
          <Grid size={{ xs: 4 }}>
            <Typography fontWeight={450}>
              <FormattedMessage id="form.labels.template" />
            </Typography>
          </Grid>
          <Grid size={{ xs: 4 }}>
            <Typography fontWeight={450}>
              <FormattedMessage id="form.labels.amount" />
            </Typography>
          </Grid>
        </Grid>
        {mysteryBox.content?.components.map(component => (
          <Grid key={component.id} container>
            <Grid size={{ xs: 4 }}>{component.tokenType}</Grid>
            <Grid size={{ xs: 4 }}>
              {component.tokenType !== TokenType.ERC20 ? (
                <Link
                  component={RouterLink}
                  to={`/${component.tokenType.toLowerCase()}/templates/${component.templateId!}`}
                >
                  {`${component.amount} x ${component.template?.title}`}
                </Link>
              ) : (
                component.template!.title
              )}
            </Grid>
            <Grid size={{ xs: 4 }}>{formatEther(component.amount, component.contract!.decimals, "")}</Grid>
          </Grid>
        ))}
      </StyledPaper>
    </>
  );
};
